import React from 'react';

export default {
  sm: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H16V16H0z" />
        <path
          className="icon-color"
          d="M14 3H2c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1s-.45 1-1 1M12.704 9.696c-.389.391-1.024.391-1.413 0l-2.29-2.292v6.593c0 .55-.45 1.001-1 1.001-.552 0-1-.45-1-1V7.403l-2.29 2.292c-.39.39-1.027.39-1.415 0-.39-.389-.39-1.025 0-1.415L7.294 4.28c.057-.06.132-.092.2-.133.041-.025.075-.06.121-.08.041-.019.087-.019.13-.029.213-.057.437-.056.641.028.044.02.077.054.118.08.07.04.142.073.204.134l3.996 4.002c.39.39.39 1.026 0 1.415"
        />
      </g>
    </svg>
  ),
  md: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H24V24H0z" />
        <path
          className="icon-color"
          d="M11 8.416V21c0 .553.447 1 1 1 .553 0 1-.447 1-1V8.416l4.122 4.121c.39.391 1.023.391 1.413 0 .392-.39.392-1.023 0-1.414L12.88 5.466c-.03-.029-.06-.056-.091-.08-.184-.235-.469-.384-.789-.384-.319 0-.604.15-.787.384-.03.024-.063.051-.09.08l-5.657 5.657c-.391.391-.391 1.023 0 1.414.39.391 1.022.391 1.413 0L11 8.417zM21 4H3c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1"
        />
      </g>
    </svg>
  ),
};
